<template>
  <div class="app-container" :style="{ height: appContainerHeight }">
    <ChatInterface />
  </div>
</template>

<script>
import { inject, computed } from "vue";
import ChatInterface from "@/components/Chat/ChatInterface.vue";

export default {
  name: "HomeView",
  components: {
    ChatInterface,
  },
  setup() {
    const totalHeaderHeight = inject("totalHeaderHeight"); // Inject the height
    const appContainerHeight = computed(() => {
      return `calc(100vh - ${totalHeaderHeight.value}px)`;
    });

    return {
      appContainerHeight,
    };
  },
};
</script>

<style scoped>
.app-container {
  display: flex;
  /* Height is now dynamically set via style binding */
}
</style>
